module.exports = __webpack_public_path__ + "img/hospitium-14.5ac70a4e.jpg";